import { Markdown, Text } from 'platform-components';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { useSelector } from 'react-redux';

import { CustomLessonInfoButton } from 'common.components/custom-lesson-info-button/custom-lesson-info-button';
import { getShouldShowCustomLessonViewInfoIcon } from 'common.components/lesson/selectors';

import './assignment__methodological-goal.scss';

interface Props extends WrappedComponentProps {
    methodologicalGoal: string | null;
}

const MethodologicalGoal = ({ methodologicalGoal, intl }: Props) => {
    const shouldShowButton = useSelector(getShouldShowCustomLessonViewInfoIcon);

    if (!methodologicalGoal) {
        return null;
    }

    return (
        <div className="assignment__methodological-goal">
            <div className="assignment__methodological-goal-label">
                <Text id="lessonView.assignment.accordionItem.methodologicalGoal" />
            </div>
            {methodologicalGoal && (
                <div>
                    <div className="assignment__methodological-goal-value">
                        <Text id={`lesson.lessonMeta.methodologicalGoals.${methodologicalGoal}`} />
                        <CustomLessonInfoButton
                            mix="assignment__custom-lesson-info-button"
                            shouldShow={shouldShowButton}
                        />
                    </div>
                </div>
            )}
            <div className="assignment__methodological-goal-description">
                <Text>
                    <Markdown>
                        {intl.formatMessage({
                            id: `lessonView.assignment.methodologicalGoals.${methodologicalGoal}.description`,
                            defaultMessage: ' ',
                        })}
                    </Markdown>
                </Text>
            </div>
        </div>
    );
};

export const AssignmentMethodologicalGoal = React.memo(injectIntl(MethodologicalGoal));
